exports.parse = require('./parse');
exports.stringify = require('./stringify');


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/